import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import moment        from 'moment';

import MovieHelpers  from '../utils/MovieHelpers';
import IntlMessages  from '../IntlMessages';
import placeholderImage from '../../../images/movies/ph-movie-poster.jpg';



const Messages = IntlMessages[MovieHelpers.getLang()];

function getEmbedUrl(movie) {
    if( movie.trailer.indexOf( 'youtube' ) > 0 ) {
        return (
            <div className="movie-details-page__video-wrapper">
                <iframe allowFullScreen src={movie.trailer.replace( 'watch?v=', 'embed/' )}/>
            </div>
        );
    } else {
        return null;
    }
}


export class MovieShowtimes extends React.PureComponent {

    static propTypes = {
        movie: PropTypes.object.isRequired
    };

    state = {
        cinema: this.props.movie.cinemas[0]
    };

    selectCinema(cinema) {
        window.logAction();
        return this.setState( { cinema } );
    }

    renderCinema(cinema) {
        const className = classNames({ selected : cinema === this.state.cinema });
        return (
            <li key={cinema.cinemaId} className={className}>
                <a onClick={() => this.selectCinema(cinema)}>
                    {cinema.cinemaName}
                </a>
            </li>
        )
    }

    renderShowTime(showTime) {
        const currentCinemaId = this.state.cinema.cinemaId;
        return (
            <td key={currentCinemaId + showTime.time}>
                <div className="movie-details-page__cinema-list__showtimes__info">
                    <span>{MovieHelpers.formatTime( showTime.time )}</span>
                    {showTime.comment ? <i className="movie-details-page__cinema-list__showtimes__info__icon"/> : null}
                    {showTime.comment ? <div className="movie-details-page__cinema-list__showtimes__info__comment">{showTime.comment}</div> : null}
                </div>
            </td>
        )
    }

    renderShowTimeList(key, showTimeList) {
        const currentCinemaId = this.state.cinema.cinemaId;

        return (
            <tr key={currentCinemaId + key}>
                <td key={`${key}h`} className="movie-details-page__cinema-list__showtimes__header">
                    {moment( key ).format( 'dddd D')}
                </td>
                {showTimeList.map(showTime => this.renderShowTime(showTime))}
            </tr>
        )
    }

    render() {
        let key;
        let showtimesGrouped = [];             // groups the showtimes by 'actual' date
        let groupedCinemas = [];               // groups the cinema by country

        // shorthands
        let currentCinemaId = this.state.cinema.cinemaId;
        let { movie } = this.props;

        for (let showtime of Array.from(this.state.cinema.showtimes)) {
            key = showtime.time;
            showtimesGrouped[ key ] = showtimesGrouped[ key ] || [];
            showtimesGrouped[ key ].push( showtime );
        }

        for (let cinema of Array.from(movie.cinemas)) {
            key = cinema.country;
            groupedCinemas[ key ] = groupedCinemas[ key ] || [];
            groupedCinemas[ key ].push( cinema );
        }

        return (
            <div>
                <ul className="movie-details-page__cinema-list">
                    { Object.values(groupedCinemas).map(cinemas => cinemas.map( c => this.renderCinema(c))) }
                </ul>
                <table key={currentCinemaId} className="movie-details-page__cinema-list__showtimes">
                    <tbody>
                        { Object.keys(showtimesGrouped).map(k => this.renderShowTimeList(k, showtimesGrouped[k])) }
                    </tbody>
                </table>
            </div>
        )
    }
}

export default class MovieDetails extends React.Component {

    static propTypes = {
        movie: PropTypes.object.isRequired
    };

    state = {
        showAdditionalInfo: false
    };

    componentDidMount() {
        setTimeout(() => { window.pymChild && window.pymChild.sendHeight() }, 1000);
    }

    componentDidUpdate() {
        window.pymChild && window.pymChild.sendHeight();
    }

    showAdditionalInfo = () => {
        return this.setState( { showAdditionalInfo: true } );
    };

    renderAdditionalInfoButton() {
        if(this.state.showAdditionalInfo) {
            return null;
        }

        return (
            <li className="show-for-small">
                <button className="movie-details-page__info__additional-info-button" onClick={this.showAdditionalInfo}>
                    Additional info
                </button>
            </li>
        )
    }

    renderVersion(movie) {
        return (
            <li key={movie._id}>
                <Link to={`/view/${movie._id}`} onClick={window.logAction}>
                    <span className="movie-details-page__info__rating-badge">
                        {movie.rating}
                    </span>
                    <span className="movie-details-page__info__format-3d-badge"
                          style={ { visibility: movie.format === '3d' ? 'visible' : 'hidden' } }>
                        {movie.rating}
                    </span>
                    <span>
                        {movie.version}
                    </span>
                </Link>
            </li>
        )
    }

    renderOtherVersions(otherVersions) {
        if(otherVersions.length === 0) {
            return null;
        }

        return (
            <li>
                <strong>Other versions</strong>
                <ul className="movie-details-page__info__other-versions">
                    {otherVersions.map(m => this.renderVersion(m))}
                </ul>
            </li>
        );
    }

    render() {
        let { movie } = this.props;

        let poster = movie.posterUrl ? <img src={movie.posterUrl} />:<img src={placeholderImage} />;
        if (movie.url) {
            poster = (
                <a href={MovieHelpers.safeLinkUrl( movie.url ) }>
                    {poster}
                </a>
            )
        }

        return (
            <section className="movie-details-page">
                <div className="pure-g">
                    <div className="pure-u-1 pure-u-lg-6-24 pure-u-md-6-24">
                        <ul className="movie-details-page__info">
                            <li className="movie-details-page__info__poster">
                                {poster}
                            </li>
                            <li>
                                <strong>{Messages.cast}</strong>
                                {movie.castAndCrew.casting}
                            </li>
                            {this.renderAdditionalInfoButton()}
                        </ul>
                        <ul className={classNames({'hide-for-small' : !this.state.showAdditionalInfo}, 'movie-details-page__info')}>
                            <li>
                                <strong>{Messages.director}</strong>
                                {movie.castAndCrew.director}
                            </li>
                            <li>
                                <strong>{Messages.producers}</strong>
                                {movie.castAndCrew.producer}
                            </li>
                            <li>
                                <strong>{Messages.writers}</strong>
                                {movie.castAndCrew.writer}
                            </li>
                            <li>
                                <strong>{Messages.distributors}</strong>
                                {movie.castAndCrew.distributor}
                            </li>
                            {this.renderOtherVersions(movie.otherVersions)}
                        </ul>
                    </div>
                    <div className="pure-u-1 pure-u-lg-18-24 pure-u-md-18-24 movie-details-page__right-container">
                        <h1 className="movie-details-page__info__overline">
                            <Link to="/" onClick={window.logAction}>
                                {Messages.allMovies}
                            </Link>
                            { ` > ${movie.genre}` }
                        </h1>
                        <h1>
                            <span>{movie.title}</span>
                            <span className="movie-details-page__info__rating-badge">
                                {movie.rating}
                            </span>
                            { movie.format === '3d' ? <span className="movie-details-page__info__format-3d-badge">3D</span> : null }
                            <span className="movie-details-page__info__subheader">
                                <span>
                                    {MovieHelpers.safeMovieDuration( movie.duration ) + ' ' + movie.version}
                                    {movie.week === -3 ? <span className="movie-details-page__info__advance-screening">{Messages.advanceScreening}</span> : null}
                                </span>
                            </span>
                        </h1>
                        <div>
                            <p>
                                {movie.synopsis}
                            </p>
                        </div>
                        {movie.cinemas.length > 0 ? <MovieShowtimes movie={movie} /> : null }
                        {movie.cinemas.length === 0 ? <span className="movie-details-page__info__no-showtimes">{Messages.noShowtimes}</span> : null }
                        <div className="movie-details-page__info__trailer">
                            {getEmbedUrl( movie )}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./js/movies/components/MovieDetails.jsx